import { ReactNode, useEffect, useState } from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import { EMPTY_FORM, TMobileSignupForm } from './form';
import { applicationToForm, stateToForm } from './mapping';
import { MobileSignupStatusProvider } from './MobileSignupStatusContext';
import {
  useGetApplicationQuery,
  useGetSelectStateQuery,
} from '../../../api/lendingApi/lendingApiQueries';
import { TGetStateResponseDE } from '../../../lapiOverrideTypesDE';

export const MobileSignupFormProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { application } = useGetApplicationQuery();
  const { normalisedState } = useGetSelectStateQuery((data) =>
    stateToForm((data as TGetStateResponseDE).data),
  );

  const methods = useForm<TMobileSignupForm>({
    // Keep fields registered across screen unmounts so values persist for the whole flow.
    shouldUnregister: false,
    defaultValues: EMPTY_FORM,
  });

  const [isSeeded, setIsSeeded] = useState(false);

  // defaultValues are captured at mount, so the async GET needs an explicit reset once
  // it resolves. keepDirtyValues preserves edits the user has already made.
  useEffect(() => {
    if (!normalisedState) return;
    methods.reset(
      { ...EMPTY_FORM, ...normalisedState, ...applicationToForm(application) },
      { keepDirtyValues: true },
    );
    setIsSeeded(true);
  }, [normalisedState, application, methods]);

  return (
    <MobileSignupStatusProvider value={{ isSeeded }}>
      <FormProvider {...methods}>{children}</FormProvider>
    </MobileSignupStatusProvider>
  );
};
